/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  WSTETHMagician,
  WSTETHMagicianInterface,
} from "../WSTETHMagician";

const _abi = [
  {
    inputs: [],
    name: "InvalidAsset",
    type: "error",
  },
  {
    inputs: [],
    name: "CURVE_POOL",
    outputs: [
      {
        internalType: "contract ICurvePoolLike",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ETH_INDEX",
    outputs: [
      {
        internalType: "int128",
        name: "",
        type: "int128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "STETH",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "STETH_INDEX",
    outputs: [
      {
        internalType: "int128",
        name: "",
        type: "int128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "WETH",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "WSTETH",
    outputs: [
      {
        internalType: "contract IWstETHLike",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "towardsAsset",
    outputs: [
      {
        internalType: "address",
        name: "tokenOut",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "towardsNative",
    outputs: [
      {
        internalType: "address",
        name: "tokenOut",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type WSTETHMagicianConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: WSTETHMagicianConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class WSTETHMagician__factory extends ContractFactory {
  constructor(...args: WSTETHMagicianConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "WSTETHMagician";
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<WSTETHMagician> {
    return super.deploy(overrides || {}) as Promise<WSTETHMagician>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): WSTETHMagician {
    return super.attach(address) as WSTETHMagician;
  }
  connect(signer: Signer): WSTETHMagician__factory {
    return super.connect(signer) as WSTETHMagician__factory;
  }
  static readonly contractName: "WSTETHMagician";
  public readonly contractName: "WSTETHMagician";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): WSTETHMagicianInterface {
    return new utils.Interface(_abi) as WSTETHMagicianInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): WSTETHMagician {
    return new Contract(address, _abi, signerOrProvider) as WSTETHMagician;
  }
}
